<template>
  <div class="page">

    <div class="main-gallery make-relative">
      <div class="thumbnail-icon" @click="toggleThumbnails($event)">
        <img src="/img/gallery-thumbs.svg" alt />
      </div>
      <swiper :options="swiperOptionTop" class="gallery-top" ref="swiperTop">
        <swiper-slide><img src="/img/gallery/th01.jpg" alt=""></swiper-slide>
        <swiper-slide><img src="/img/gallery/th02.jpg" alt=""></swiper-slide>
        <swiper-slide><img src="/img/gallery/th03.jpg" alt=""></swiper-slide>
        <swiper-slide><img src="/img/gallery/th04.jpg" alt=""></swiper-slide>
        <swiper-slide><img src="/img/gallery/th05.jpg" alt=""></swiper-slide>
        <swiper-slide><img src="/img/gallery/th06.jpg" alt=""></swiper-slide>
        <swiper-slide><img src="/img/gallery/th07.jpg" alt=""></swiper-slide>
        <swiper-slide><img src="/img/gallery/th08.jpg" alt=""></swiper-slide>
        <swiper-slide><img src="/img/gallery/th09.jpg" alt=""></swiper-slide>
        <swiper-slide><img src="/img/gallery/th10.jpg" alt=""></swiper-slide>
        <swiper-slide><img src="/img/gallery/img-1.jpg" alt /></swiper-slide>
        <!-- <swiper-slide><img src="/img/gallery/img-2.jpg" alt=""></swiper-slide> -->
        <!-- <swiper-slide><img src="/img/gallery/img-3.jpg" alt=""></swiper-slide> -->
        <swiper-slide><img src="/img/gallery/img-4.jpg" alt=""></swiper-slide>
        <!-- <swiper-slide><img src="/img/gallery/img-5.jpg" alt=""></swiper-slide> -->
        <!-- <swiper-slide><img src="/img/gallery/img-6.jpg" alt=""></swiper-slide> -->
        <!-- <swiper-slide><img src="/img/gallery/img-7.jpg" alt=""></swiper-slide> -->
        <!-- <swiper-slide><img src="/img/gallery/img-8.jpg" alt=""></swiper-slide> -->
        <!-- <swiper-slide><img src="/img/gallery/img-9.jpg" alt=""></swiper-slide> -->
        <!-- <swiper-slide><img src="/img/gallery/img-10.jpg" alt=""></swiper-slide> -->
        <!-- <swiper-slide><img src="/img/gallery/img-11.jpg" alt /></swiper-slide> -->
        <!-- <swiper-slide><img src="/img/gallery/img-12.jpg" alt=""></swiper-slide> -->
        <!-- <swiper-slide><img src="/img/gallery/img-13.jpg" alt=""></swiper-slide> -->
        <!-- <swiper-slide><img src="/img/gallery/img-14.jpg" alt=""></swiper-slide> -->
        <!-- <swiper-slide><img src="/img/gallery/img-15.jpg" alt=""></swiper-slide> -->
        <!-- <swiper-slide><img src="/img/gallery/img-16.jpg" alt=""></swiper-slide> -->
        <!-- <swiper-slide><img src="/img/gallery/img-17.jpg" alt=""></swiper-slide> -->
        <!-- <swiper-slide><img src="/img/gallery/img-18.jpg" alt=""></swiper-slide> -->
        <!-- <swiper-slide><img src="/img/gallery/img-19.jpg" alt=""></swiper-slide> -->
        <!-- <swiper-slide><img src="/img/gallery/img-20.jpg" alt=""></swiper-slide> -->

        <div class="swiper-button-next swiper-button" slot="button-next"></div>
        <div class="swiper-button-prev swiper-button" slot="button-prev"></div>
      </swiper>
    </div>
    <!-- Thumbs -->

    <div class="gallery-thumbs-container">
      <div class="close-icon" @click="toggleThumbnails($event)">
        <img src="/img/cross-blue.png" alt="Close" />
      </div>
      <swiper :options="swiperOptionThumbs" class="gallery-thumbs" ref="swiperThumbs">
        <swiper-slide><img src="/img/gallery/th01.jpg" alt=""></swiper-slide>
        <swiper-slide><img src="/img/gallery/th02.jpg" alt=""></swiper-slide>
        <swiper-slide><img src="/img/gallery/th03.jpg" alt=""></swiper-slide>
        <swiper-slide><img src="/img/gallery/th04.jpg" alt=""></swiper-slide>
        <swiper-slide><img src="/img/gallery/th05.jpg" alt=""></swiper-slide>
        <swiper-slide><img src="/img/gallery/th06.jpg" alt=""></swiper-slide>
        <swiper-slide><img src="/img/gallery/th07.jpg" alt=""></swiper-slide>
        <swiper-slide><img src="/img/gallery/th08.jpg" alt=""></swiper-slide>
        <swiper-slide><img src="/img/gallery/th09.jpg" alt=""></swiper-slide>
        <swiper-slide><img src="/img/gallery/th10.jpg" alt=""></swiper-slide>
        <swiper-slide><img src="/img/gallery/img-1.jpg" alt /></swiper-slide>

        <!-- <swiper-slide><img src="/img/gallery/img-2.jpg" alt=""></swiper-slide> -->
        <!-- <swiper-slide><img src="/img/gallery/img-3.jpg" alt=""></swiper-slide> -->
        <swiper-slide><img src="/img/gallery/img-4.jpg" alt=""></swiper-slide>
        <!-- <swiper-slide><img src="/img/gallery/img-5.jpg" alt=""></swiper-slide> -->
        <!-- <swiper-slide><img src="/img/gallery/img-6.jpg" alt=""></swiper-slide> -->
        <!-- <swiper-slide><img src="/img/gallery/img-7.jpg" alt=""></swiper-slide> -->
        <!-- <swiper-slide><img src="/img/gallery/img-8.jpg" alt=""></swiper-slide> -->
        <!-- <swiper-slide><img src="/img/gallery/img-9.jpg" alt=""></swiper-slide> -->
        <!-- <swiper-slide><img src="/img/gallery/img-10.jpg" alt=""></swiper-slide> -->
        <!-- <swiper-slide><img src="/img/gallery/img-11.jpg" alt /></swiper-slide> -->
        <!-- <swiper-slide><img src="/img/gallery/img-12.jpg" alt=""></swiper-slide> -->
        <!-- <swiper-slide><img src="/img/gallery/img-13.jpg" alt=""></swiper-slide> -->
        <!-- <swiper-slide><img src="/img/gallery/img-14.jpg" alt=""></swiper-slide> -->
        <!-- <swiper-slide><img src="/img/gallery/img-15.jpg" alt=""></swiper-slide> -->
        <!-- <swiper-slide><img src="/img/gallery/img-16.jpg" alt=""></swiper-slide> -->
        <!-- <swiper-slide><img src="/img/gallery/img-17.jpg" alt=""></swiper-slide> -->
        <!-- <swiper-slide><img src="/img/gallery/img-18.jpg" alt=""></swiper-slide> -->
        <!-- <swiper-slide><img src="/img/gallery/img-19.jpg" alt=""></swiper-slide> -->
        <!-- <swiper-slide><img src="/img/gallery/img-20.jpg" alt=""></swiper-slide> -->
   
      </swiper>
    </div>

  </div>
</template>

<script>
  import {
    Swiper,
    SwiperSlide,
    directive
  } from 'vue-awesome-swiper'
  import 'swiper/css/swiper.css'

  export default {
    data() {
      return {
        swiperOptionTop: {
          spaceBetween: 0,
          loop: true,
          autoplay: {
            delay: 5500,
          },
          loopedSlides: 20, //looped slides should be the same
          slidesPerView: 1,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
          }
        },
        swiperOptionThumbs: {
          spaceBetween: 10,
          slidesPerView: 20,
          slidesPerColumn: 4,

          slidesPerColumnFill: "row",
          width: 340,
          height: 190,
          touchRatio: 0.2,
          loopedSlides: 20, //looped slides should be the same
          slideToClickedSlide: true,
          preventClicks: false
        },
        sliderThumbs: "",
      }
    }, //data
    components: {
      Swiper,
      SwiperSlide
    }, //components
    directives: {
      swiper: directive
    }, //directives
    mounted() {
      this.$nextTick(() => {
        const swiperTop = this.$refs.swiperTop.$swiper
        const swiperThumbs = this.$refs.swiperThumbs.$swiper
        swiperTop.controller.control = swiperThumbs

      })
      var $this = this;
      this.sliderThumbs = document.querySelectorAll(
        ".gallery-thumbs-container .swiper-slide"
      );
      this.sliderThumbs.forEach((elem, index) => {
        elem.addEventListener("click", function (e) {

          $this.$refs.swiperTop.$swiper.slideToLoop(index, 300);
          $this.toggleThumbnails(e);
        });
      });

    }, //mounted
    methods: {
      toggleThumbnails($event) {
        document.querySelector(".thumbnail-icon").classList.toggle("active");
        document
          .querySelector(".gallery-thumbs-container")
          .classList.toggle("active");

      }
    }
  }
</script>

<style lang="scss">
  .swiper-button-prev,
  .swiper-button-next {
    color: white;
  }

  .main-gallery {
    width: 100%;
    height: 100%;

    .thumbnail-icon {
      cursor: pointer;
      position: absolute;
      bottom: 50px;
      top: auto;
      width: 100%;
      margin: 0 auto;
      z-index: 10;
    }
  }

  .gallery-thumbs-container {
    position: relative;
    padding: 100px 70px;
    background-color: white;
    position: absolute;
    box-sizing: border-box;
    padding: 80px 70px;
    top: 100%;
    height: 100%;
    width: 100%;
    transition: all 0.3s ease-out;

    &.active {
      top: 0;
      opacity: 1;
      z-index: 100;
    }

    .close-icon {
      position: absolute;
      top: 30px;
      right: 50px;
      z-index: 9;
    }


  }
  .gallery-thumbs .swiper-slide img{
    object-fit: cover;
    object-position: center;
  }
  .gallery-thumbs {
    .swiper-wrapper {
      width: 100% !important;
      display: flex;
      justify-content: center;
    }

    .swiper-slide {
      /* width: 340px !important; */
      flex: 0 1 32%;
    max-width: 22%;
    height: 270px;

      max-height: 25%;
      overflow: hidden;
      opacity: 1;
      border: 10px solid transparent;
      margin: 0;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .swiper-slide-active {
      opacity: 1;
    }
  }
</style>